import omit from 'lodash-es/omit';
import { FunctionComponent } from 'react';

import { MODAL_TYPES } from '../constants/common';

type ModalPropsType = { onClose: () => void; params: any };

export type ModalsRecordType<T extends string> = {
  [key in T]?: FunctionComponent<ModalPropsType>;
};

class ModalsRegistry<T extends string> {
  constructor(modals: ModalsRecordType<T>) {
    this.modals = modals;
  }

  modals: ModalsRecordType<T>;

  injectModals = (modals: ModalsRecordType<T>): void => {
    this.modals = { ...this.modals, ...modals };
  };

  removeModals = (modalNames: MODAL_TYPES[]): void => {
    this.modals = omit(this.modals, modalNames) as ModalsRecordType<T>;
  };

  getModals = (): ModalsRecordType<T> => this.modals;

  getSpecificModal = (key: T): FunctionComponent<ModalPropsType> | null =>
    this.modals[key] || null;
}

export default ModalsRegistry;
